import { formatInTimeZone } from "date-fns-tz";

/**
 * Format a date as a short string (e.g. "Apr 9").
 * If a timezone is provided, the date is converted to that timezone first.
 */
export const formatShortDate = (date: Date, timeZone?: string): string => {
  if (timeZone) {
    return formatInTimeZone(date, timeZone, "MMM d");
  }
  return date.toLocaleDateString([], { month: "short", day: "numeric" });
};

/**
 * Format a date as a short string with year (e.g. "Apr 9, 2026").
 * If a timezone is provided, the date is converted to that timezone first.
 */
export const formatShortDateWithYear = (
  date: Date,
  timeZone?: string
): string => {
  if (timeZone) {
    return formatInTimeZone(date, timeZone, "MMM d, yyyy");
  }
  return date.toLocaleDateString([], {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
};
